import React, { useState } from "react";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Avatar from "@material-ui/core/Avatar";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
  side: {
    padding: theme.spacing(2),
    height: "100%",
  },
  avatar: {
    width: 64,
    height: 64,
    margin: "0 auto",
    marginBottom: theme.spacing(1),
  },
  field: {
    marginBottom: theme.spacing(1),
  },
  label: {
    fontWeight: "bold",
  },
}));

// Mostra lado a lado os dados do mesmo contato no SacZap e no Google, pra
// escolher qual versão manter quando os dois já têm um cadastro com o mesmo
// número mas informações diferentes.
const GoogleContactCompareModal = ({ open, onClose, data, onResolved }) => {
  const classes = useStyles();
  const [resolving, setResolving] = useState(null); // "saczap" | "google" | null

  if (!data) return null;
  const { saczap, google } = data;

  const handleKeep = async keep => {
    setResolving(keep);
    try {
      await api.post(`/google-contacts/resolve/${saczap.id}`, {
        keep,
        googleResourceName: google.resourceName,
        googleEtag: google.etag,
        googleName: google.name,
        googleEmail: google.email,
      });
      toast.success(
        keep === "saczap"
          ? "Contato do Google atualizado com os dados do SacZap."
          : "Contato do SacZap atualizado com os dados do Google."
      );
      if (onResolved) onResolved();
      onClose();
    } catch (err) {
      toastError(err);
    } finally {
      setResolving(null);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Esse contato já existe nos dois lados</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Mesmo número encontrado no SacZap e no Google Contatos, com dados diferentes.
          Escolha qual versão manter — a outra será sobrescrita.
        </Typography>
        <Grid container spacing={2} style={{ marginTop: 8 }}>
          <Grid item xs={6}>
            <Paper variant="outlined" className={classes.side}>
              <Typography variant="subtitle2" align="center" gutterBottom>
                SacZap
              </Typography>
              <Avatar
                className={classes.avatar}
                src={saczap.photoUrl || undefined}
              />
              <Typography variant="body2" className={classes.field}>
                <span className={classes.label}>Nome:</span> {saczap.name || "-"}
              </Typography>
              <Typography variant="body2" className={classes.field}>
                <span className={classes.label}>Número:</span> {saczap.number || "-"}
              </Typography>
              <Typography variant="body2" className={classes.field}>
                <span className={classes.label}>Email:</span> {saczap.email || "-"}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={6}>
            <Paper variant="outlined" className={classes.side}>
              <Typography variant="subtitle2" align="center" gutterBottom>
                Google
              </Typography>
              <Avatar
                className={classes.avatar}
                src={google.photoUrl || undefined}
              />
              <Typography variant="body2" className={classes.field}>
                <span className={classes.label}>Nome:</span> {google.name || "-"}
              </Typography>
              <Typography variant="body2" className={classes.field}>
                <span className={classes.label}>Número:</span> {google.number || "-"}
              </Typography>
              <Typography variant="body2" className={classes.field}>
                <span className={classes.label}>Email:</span> {google.email || "-"}
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancelar
        </Button>
        <Button
          onClick={() => handleKeep("google")}
          color="primary"
          variant="outlined"
          disabled={!!resolving}
        >
          {resolving === "google" ? (
            <CircularProgress size={20} />
          ) : (
            "Manter do Google"
          )}
        </Button>
        <Button
          onClick={() => handleKeep("saczap")}
          color="primary"
          variant="contained"
          disabled={!!resolving}
        >
          {resolving === "saczap" ? (
            <CircularProgress size={20} />
          ) : (
            "Manter do SacZap"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GoogleContactCompareModal;
